/* NEXRA Quick View (Teveo-style).
   Nut "+" tren the san pham -> mo drawer ben phai, noi dung nap bang AJAX tu
   sections/nx-quick-view.liquid. Moi mau (color) da duoc render san trong HTML
   nen doi mau khong phai fetch lai. Them vao gio bang AJAX + mo cart drawer. */
(function () {
  if (customElements.get('nx-quick-add')) return;

  var SECTION = 'nx-quick-view';
  var cache = Object.create(null);
  var drawer = null;
  var lastTrigger = null;

  /* ---------- drawer dung chung, gan mot lan vao <body> ---------- */
  function buildDrawer() {
    if (drawer) return drawer;
    var el = document.createElement('div');
    el.className = 'nx-qv-drawer';
    el.setAttribute('hidden', '');
    el.innerHTML =
      '<div class="nx-qv-drawer__backdrop" data-close></div>' +
      '<div class="nx-qv-drawer__panel" role="dialog" aria-modal="true" aria-label="Quick view">' +
        '<div class="nx-qv-drawer__header">' +
          '<h3 class="nx-qv-drawer__title">Quick View</h3>' +
          '<button type="button" class="nx-qv-drawer__close" data-close aria-label="Close">' +
            '<svg viewBox="0 0 18 17" width="15" height="15" aria-hidden="true" focusable="false">' +
            '<path d="M.865 15.978a.5.5 0 00.707.707l7.433-7.431 7.579 7.282a.501.501 0 00.846-.37.5.5 0 00-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 10-.707-.708L8.991 7.853 1.413.573a.5.5 0 10-.693.72l7.563 7.268-7.418 7.417z" fill="currentColor"/></svg>' +
          '</button>' +
        '</div>' +
        '<div class="nx-qv-drawer__content"></div>' +
      '</div>';
    document.body.appendChild(el);

    el.addEventListener('click', function (e) {
      if (e.target.closest('[data-close]')) { e.preventDefault(); closeDrawer(); return; }
      onContentClick(e);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer && !drawer.hasAttribute('hidden')) closeDrawer();
    });
    drawer = el;
    return el;
  }

  function skeleton() {
    var chips = '';
    for (var i = 0; i < 5; i++) chips += '<span class="nx-qv-sk nx-qv-sk--chip"></span>';
    var rel = '';
    for (var j = 0; j < 5; j++) rel += '<span class="nx-qv-sk nx-qv-sk--rel"></span>';
    return '<div class="nx-qv nx-qv--loading" aria-busy="true">' +
      '<div class="nx-qv__info">' +
        '<div class="nx-qv__image"><span class="nx-qv-sk nx-qv-sk--img"></span></div>' +
        '<div class="nx-qv__body">' +
          '<span class="nx-qv-sk nx-qv-sk--line" style="width:38%"></span>' +
          '<span class="nx-qv-sk nx-qv-sk--line" style="width:78%;height:1.8rem"></span>' +
          '<span class="nx-qv-sk nx-qv-sk--line" style="width:52%"></span>' +
          '<span class="nx-qv-sk nx-qv-sk--line" style="width:30%"></span>' +
        '</div>' +
      '</div>' +
      '<div class="nx-qv__variants">' +
        '<div class="nx-qv__form-header"><span class="nx-qv-sk nx-qv-sk--line" style="width:60px"></span></div>' +
        '<div class="nx-qv__sizes-box"><div class="nx-qv__sizes" style="--nx-qv-cols:5">' + chips + '</div></div>' +
      '</div>' +
      '<span class="nx-qv-sk nx-qv-sk--btn"></span>' +
      '<div class="nx-qv__related"><div class="nx-qv__related-title"><span class="nx-qv-sk nx-qv-sk--line" style="width:55%"></span></div>' +
      '<div class="nx-qv__related-list">' + rel + '</div></div>' +
    '</div>';
  }

  function openDrawer(trigger, url) {
    var el = buildDrawer();
    el.dataset.nxWant = url;
    lastTrigger = trigger;
    el.querySelector('.nx-qv-drawer__content').innerHTML = cache[url] || skeleton();
    el.removeAttribute('hidden');
    document.documentElement.classList.add('nx-qadd-lock');
    // ep mot lan paint o trang thai dong roi moi mo -> transition chay that
    void el.offsetWidth;
    requestAnimationFrame(function () { el.classList.add('is-open'); });
    if (cache[url]) { afterRender(); return; }
    load(url);
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    document.documentElement.classList.remove('nx-qadd-lock');
    setTimeout(function () {
      if (drawer && !drawer.classList.contains('is-open')) drawer.setAttribute('hidden', '');
    }, 320);
    if (lastTrigger) { try { lastTrigger.focus({ preventScroll: true }); } catch (e) {} }
  }

  function load(url) {
    var sep = url.indexOf('?') > -1 ? '&' : '?';
    fetch(url + sep + 'section_id=' + SECTION, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var body = doc.querySelector('.nx-qv');
        if (!body) throw new Error('no .nx-qv');
        cache[url] = body.outerHTML;
        if (!drawer || drawer.hasAttribute('hidden')) return;
        // bam doi mau lien tiep: chi chen noi dung cua lan bam CUOI
        if (drawer.dataset.nxWant && drawer.dataset.nxWant !== url) return;
        drawer.querySelector('.nx-qv-drawer__content').innerHTML = cache[url];
        afterRender();
      })
      .catch(function () {
        if (!drawer) return;
        drawer.querySelector('.nx-qv-drawer__content').innerHTML =
          '<div class="nx-qv nx-qv--error"><p>Could not load this product. Please try again.</p></div>';
      });
  }

  /* ---------- sau khi noi dung vao DOM ---------- */
  function afterRender() {
    var root = drawer && drawer.querySelector('.nx-qv');
    if (!root) return;
    // Bang size cua san pham render ben trong .nx-qv (de nam trong cache theo URL),
    // nhung phai nam o <body> moi phu duoc len drawer — trong panel fixed cua
    // drawer thi no bi cat va bi nhot duoi z-index cua panel.
    var sc = root.querySelector('.nx-sc');
    if (sc) {
      // ⚠️ Dung getElementById de don ban cu: no tra ve ban DAU TIEN theo thu tu
      // DOM, ma ban moi (dang trong drawer) lai dung truoc ban cu o body -> khong
      // xoa duoc gi, roi ton tai HAI modal cung id va modal mo ra la cua san pham
      // TRUOC. Phai quet querySelectorAll roi bo moi ban khong phai ban moi.
      document.querySelectorAll('#' + sc.id).forEach(function (el) {
        if (el !== sc) el.remove();
      });
      document.body.appendChild(sc);
    }
    var atc = root.querySelector('.nx-qv__atc');
    if (atc) { atc.disabled = true; atc.textContent = atc.dataset.labelPick || 'Select a size'; }
  }

  function swapTo(url) {
    if (!drawer) return;
    drawer.dataset.nxWant = url;
    var box = drawer.querySelector('.nx-qv-drawer__content');
    if (cache[url]) { box.innerHTML = cache[url]; afterRender(); return; }
    box.innerHTML = skeleton();
    load(url);
  }

  function activeSizes(root) {
    return root.querySelector('.nx-qv__sizes:not([hidden])');
  }

  function onContentClick(e) {
    var root = drawer.querySelector('.nx-qv');
    if (!root) return;

    var sw = e.target.closest('.nx-qv__swatch');
    // NEXRA 14/09: listing tach mau - swatch la SAN PHAM KHAC -> nap Quick View cua SP do.
    if (sw && sw.dataset.qvUrl) { e.preventDefault(); swapTo(sw.dataset.qvUrl); return; }
    if (sw) { e.preventDefault(); pickColor(root, sw); return; }

    var size = e.target.closest('.nx-qv__size');
    if (size && !size.disabled) { e.preventDefault(); pickSize(root, size); return; }

    var atc = e.target.closest('.nx-qv__atc');
    if (atc && !atc.disabled) { e.preventDefault(); addToCart(root, atc); }
  }

  function pickColor(root, sw) {
    var color = sw.dataset.color || '';
    showError(root, '');
    root.querySelectorAll('.nx-qv__swatch').forEach(function (b) {
      b.classList.toggle('is-active', b === sw);
    });
    root.querySelectorAll('.nx-qv__sizes').forEach(function (d) {
      if ((d.dataset.color || '') === color) d.removeAttribute('hidden');
      else d.setAttribute('hidden', '');
    });
    var img = root.querySelector('.nx-qv__img');
    if (img && sw.dataset.img) { img.src = sw.dataset.img; img.alt = color; }
    var cname = root.querySelector('.nx-qv__color');
    if (cname) cname.textContent = color;
    var price = root.querySelector('.nx-qv__price');
    if (price && sw.dataset.price) price.innerHTML = sw.dataset.price;
    var sel = root.querySelector('.nx-qv__related-sel');
    if (sel) sel.textContent = '(Selected ' + color + ')';
    // doi mau = bo size da chon (size cua mau cu khong con nghia)
    root.querySelectorAll('.nx-qv__size.is-selected').forEach(function (b) { b.classList.remove('is-selected'); });
    var atc = root.querySelector('.nx-qv__atc');
    if (atc) {
      atc.disabled = true;
      atc.textContent = atc.dataset.labelPick || 'Select a size';
      atc.removeAttribute('data-variant-id');
    }
  }

  function pickSize(root, btn) {
    showError(root, '');
    var wrap = activeSizes(root) || root;
    wrap.querySelectorAll('.nx-qv__size').forEach(function (b) { b.classList.remove('is-selected'); });
    btn.classList.add('is-selected');
    var atc = root.querySelector('.nx-qv__atc');
    if (atc) {
      atc.dataset.variantId = btn.dataset.variantId || '';
      atc.disabled = false;
      atc.textContent = atc.dataset.labelAdd || 'Add to cart';
    }
  }

  /* NEXRA 02/10: bao loi BANG CHU khi them gio that bai (truoc do: mat mang thi im lang, 422 chi nhay do 1,4s).
     Khoi .nx-qv__error render san trong sections/nx-quick-view.liquid, ngay tren nut; cung kieu chu voi
     .product-form__error-message-wrapper cua nut chinh tren trang san pham. */
  var MSG_NET = 'Could not add to cart. Check your connection and try again.';
  var MSG_FAIL = 'Could not add to cart. Please try again.';
  function showError(root, msg) {
    if (!root) return;
    var box = root.querySelector('.nx-qv__error');
    if (!box) {
      // HTML Quick View cu (chua co khoi bao loi) -> tu tao ngay tren nut
      if (!msg) return;
      var atc = root.querySelector('.nx-qv__atc');
      if (!atc || !atc.parentNode) return;
      box = document.createElement('div');
      box.className = 'nx-qv__error';
      box.setAttribute('role', 'alert');
      box.innerHTML = '<span class="nx-qv__error-msg"></span>';
      atc.parentNode.insertBefore(box, atc);
    }
    var txt = box.querySelector('.nx-qv__error-msg');
    if (txt) txt.textContent = msg || '';
    if (msg) box.removeAttribute('hidden'); else box.setAttribute('hidden', '');
  }
  function flashError(btn) {
    btn.classList.add('is-error');
    setTimeout(function () { btn.classList.remove('is-error'); }, 1400);
  }

  var loading = false;
  function addToCart(root, btn) {
    var variantId = btn.dataset.variantId;
    if (loading || !variantId) return;
    // NEXRA 09/10 (tam ngung ban): bien the nam trong settings.nx_chan_ids (window.NX_CHAN) thi khong gui them gio.
    if (window.NX_CHAN && window.NX_CHAN.indexOf(String(variantId)) > -1) {
      showError(root, (window.variantStrings && window.variantStrings.soldOut) || 'Sold out');
      flashError(btn);
      return;
    }
    loading = true;
    btn.classList.add('is-loading');
    showError(root, '');
    var netErr = false;

    var cartDrawer = document.querySelector('cart-drawer');
    var fd = new FormData();
    fd.append('id', variantId);
    fd.append('quantity', 1);
    fd.append('sections', cartDrawer ? 'cart-drawer,cart-icon-bubble' : 'cart-icon-bubble');
    fd.append('sections_url', window.location.pathname);

    var url = (window.routes && window.routes.cart_add_url) ? window.routes.cart_add_url : '/cart/add';
    fetch(url, {
      method: 'POST',
      headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: fd
    })
      .then(function (r) { return r.json(); })
      // Chi loi cua fetch / doc JSON (mat mang, server tra trang loi) moi tinh la "khong them duoc".
      // Loi nem ra SAU khi da them xong (luc ve lai gio) khong duoc bao nham la them that bai.
      .catch(function (e) { netErr = true; throw e; })
      .then(function (res) {
        if (res && res.status) {
          flashError(btn);
          var why = (typeof res.description === 'string' && res.description) ||
                    (typeof res.message === 'string' && res.message) || MSG_FAIL;
          showError(root, why);
          return;
        }
        closeDrawer();
        if (cartDrawer && res.sections) {
          // ⚠️ Phai go `is-empty` tren CHINH the <cart-drawer>, khong phai .drawer__inner.
          // CSS cua Dawn: `.is-empty .cart__contents { display: none }` va
          // `cart-drawer.is-empty .drawer__header { display: none }` — deu neo vao the host.
          // Neu trang duoc tai luc gio con RONG thi class do dinh mai (renderContents chi
          // thay innerHTML, khong dung toi class cua host) -> them hang xong drawer mat
          // ca tieu de lan danh sach san pham, chi con footer. Dawn lam dung o
          // product-form.js:115 `this.cart.classList.remove('is-empty')`.
          cartDrawer.classList.remove('is-empty');
          var inner = cartDrawer.querySelector('.drawer__inner');
          if (inner) inner.classList.remove('is-empty');
          var itemsEl = cartDrawer.querySelector('cart-drawer-items');
          if (itemsEl) itemsEl.classList.remove('is-empty');
          if (typeof cartDrawer.renderContents === 'function') cartDrawer.renderContents(res);
        } else {
          window.location = (window.routes && window.routes.cart_url) ? window.routes.cart_url : '/cart';
        }
      })
      .catch(function () {
        if (!netErr) return;
        flashError(btn);
        showError(root, MSG_NET);
      })
      .finally(function () {
        loading = false;
        btn.classList.remove('is-loading');
      });
  }

  /* ---------- trigger tren the san pham ---------- */
  class NxQuickAdd extends HTMLElement {
    constructor() {
      super();
      this.trigger = this.querySelector('.nx-qadd__trigger');
      var self = this;
      if (this.trigger) {
        this.trigger.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          openDrawer(self.trigger, self.dataset.productUrl);
        });
      }
      // Dawn phu ca the card bang .card__heading a::after (z-index 1). Neu vi ly do
      // nao do nut nam duoi lop do thi cu bam la nhay sang PDP -> chan o pha CAPTURE
      // theo toa do nut, giu nguyen viec bam vao anh van mo PDP.
      var card = this.closest('.card-wrapper') || this.closest('.card') || this.parentElement;
      if (card && this.trigger) {
        card.addEventListener('click', function (e) {
          if (e.target.closest('.nx-qadd')) return;
          var r = self.trigger.getBoundingClientRect();
          var pad = 4;
          if (e.clientX >= r.left - pad && e.clientX <= r.right + pad &&
              e.clientY >= r.top - pad && e.clientY <= r.bottom + pad) {
            e.preventDefault();
            e.stopPropagation();
            openDrawer(self.trigger, self.dataset.productUrl);
          }
        }, true);
      }
    }
  }

  customElements.define('nx-quick-add', NxQuickAdd);
})();
